import './App.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { PrivateRoute } from "./routes/PrivateRoute";
import LoginLayout from './layout/loginLayout';
import DashboardLayout from './layout/dashboardLayout';
import Users from './pages/users/users';
import Dashboard from './pages/dashboard/dashboard';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PrivateRoute />}>
          {/* specify private routes here  */}
          <Route path="/" element={<DashboardLayout/>}>
            <Route index element={<Dashboard/>} />
            <Route path="/users" element={<Users/>} />
          </Route>
        </Route>

        {/* specify public routes here */}
        <Route path="/login" element={<LoginLayout />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
